import authInterceptor from './auth.interceptor'
import languages from '../language'

function AppConfig($httpProvider, $stateProvider, $locationProvider, $urlRouterProvider, $translateProvider, cfpLoadingBarProvider, IdleProvider, KeepaliveProvider) {
  'ngInject';

  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.includeBar = true;

  $locationProvider.html5Mode(true);
  $httpProvider.interceptors.push(authInterceptor)

  const languageMapping = {
    en: 'E',
    es: 'S'
  };

  // $stateProvider
  // .state('app', {
  //   abstract: true,
  //   templateUrl: 'layout/app-view.html',
  //   resolve: {
  //     auth: function(User) {
  //       debugger;
  //       return User.verifyAuth();
  //     }
  //   }
  // })

  $urlRouterProvider.otherwise('/app/home')

  // Install all the languages
  $translateProvider.useLoader('LanguageLoaderService');
  $translateProvider.forceAsyncReload(true);
  $translateProvider.useSanitizeValueStrategy('');

  // Detect Browser language and set as default
  let browserLanguage = navigator.language || navigator.browserLanguage

  if (browserLanguage) {
    browserLanguage = browserLanguage.split('-')[0]
    $translateProvider.preferredLanguage(languageMapping[browserLanguage])
  } else {
    $translateProvider.preferredLanguage(languageMapping.en)
  }

  IdleProvider.timeout(10);
  IdleProvider.autoResume(true);
  KeepaliveProvider.interval(10);

  const sessionLength = JSON.parse(localStorage.getItem('sessionLength'));
  if (sessionLength) {
    IdleProvider.idle(sessionLength * 60);
  }
}

export default AppConfig;



// WEBPACK FOOTER //
// ./client/app/config/app.config.js